<template>
  <div class="reading-card">
    <span class="reading-card__title">{{ $t('page.about.readingCard.title') }}</span>
    <div class="reading-card__book">
      <div class="book-cover">
        <img :src="book.cover" :alt="book.title" />
      </div>
      <div class="book-info">
        <span class="book-info__title">{{ book.title }}</span>
        <span class="book-info__author">{{ book.author }}</span>
        <div class="book-progress">
          <div class="progress-bar">
            <div class="progress-fill" :style="{ width: book.progress + '%' }"></div>
          </div>
          <span class="progress-text">{{ book.progress }}%</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive } from 'vue'

import readingCardCover from '@/assets/images/reading/reading-card-cover.jpg'

// Libro actual (puedes modificar estos valores)
const book = reactive({
  title: 'Cosmos',
  author: 'Carl Sagan',
  progress: 50,
  cover: readingCardCover,
})
</script>

<style scoped>
.reading-card {
  @apply p-5 h-full flex flex-col;
}

.reading-card__title {
  @apply text-xs uppercase tracking-wider mb-4;
  color: var(--color-text-muted);
}

.reading-card__book {
  @apply flex gap-4 flex-1;
}

.book-cover {
  @apply h-28 flex-shrink-0 transition-transform duration-300;
  box-shadow: 0 5px 20px -5px rgba(0, 0, 0, 1);
}

.book-cover img {
  @apply w-full h-full object-cover;
}

.book-info {
  @apply flex flex-col flex-1 min-w-0;
}

.book-info__title {
  @apply text-sm font-bold leading-tight mb-1 truncate;
  color: var(--color-text-primary);
}

.book-info__author {
  @apply text-xs;
  color: var(--color-text-muted);
}

.book-progress {
  @apply flex items-center gap-2 mt-auto;
}

.progress-bar {
  @apply flex-1 h-1.5 rounded-full overflow-hidden;
  background: var(--color-surface-elevated);
}

.progress-fill {
  @apply h-full rounded-full transition-all duration-1000 ease-out;
  background: linear-gradient(90deg, var(--color-electric-purple) 0%, #818cf8 100%);
}

.progress-text {
  @apply text-xs font-semibold;
  color: var(--color-electric-purple);
}
</style>
